import React from 'react';
import { Skeleton, Typography, Space } from 'antd';

const { Text } = Typography;

const FeaturedLotCardSkeleton = () => {
    return (
        <>
            <div style={{
                borderRadius: '16px',
                overflow: 'hidden',
                height: '100%',
                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                border: '1px solid #e8eaed',
                boxShadow: '0 2px 12px rgba(0, 0, 0, 0.06)',
                background: 'rgba(255, 255, 255, 0.95)',
                backdropFilter: 'blur(10px)'
            }} className="featured-lot-skeleton-card">
                {/* Header with image skeleton */}
                <div style={{ 
                    position: 'relative',
                    height: 160,
                    background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'column',
                    gap: '12px'
                }}>
                    <div style={{
                        width: '60px',
                        height: '60px',
                        borderRadius: '50%',
                        background: 'rgba(255, 255, 255, 0.2)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: 'white',
                        fontSize: '24px',
                        fontWeight: 'bold',
                        backdropFilter: 'blur(10px)'
                    }}>
                        M
                    </div>
                    <Text style={{ 
                        fontSize: '12px', 
                        textAlign: 'center',
                        color: 'rgba(255, 255, 255, 0.9)',
                        fontWeight: 500
                    }}>
                        Maveshibids
                    </Text>
                    
                    {/* Featured badge skeleton */}
                    <div style={{
                        position: 'absolute',
                        top: 8,
                        left: 8,
                        zIndex: 2
                    }}>
                        <Skeleton.Button active style={{ 
                            width: '70px', 
                            height: '22px', 
                            borderRadius: '12px',
                            background: 'rgba(255, 255, 255, 0.3)'
                        }} />
                    </div>
                    
                    {/* Status tag skeleton */}
                    <div style={{
                        position: 'absolute',
                        top: 8,
                        right: 8,
                        zIndex: 2
                    }}>
                        <Skeleton.Button active style={{ 
                            width: '50px', 
                            height: '20px', 
                            borderRadius: '12px',
                            background: 'rgba(255, 255, 255, 0.3)'
                        }} />
                    </div>
                </div>
                
                {/* Body content skeleton */}
                <div style={{ padding: '16px' }}>
                    <Space direction="vertical" size="small" style={{ width: '100%' }}>
                        <div>
                            <Skeleton.Input 
                                active 
                                style={{ 
                                    width: '80px',
                                    height: '18px',
                                    marginBottom: 8,
                                    borderRadius: '12px'
                                }} 
                            />
                            <Skeleton.Input 
                                active 
                                style={{ 
                                    width: '90%',
                                    height: '20px',
                                    marginBottom: 4
                                }} 
                            />
                            <Skeleton.Input 
                                active 
                                style={{ 
                                    width: '70%',
                                    height: '14px',
                                    marginBottom: 8
                                }} 
                            />
                        </div>

                        <div style={{ 
                            display: 'flex', 
                            justifyContent: 'space-between', 
                            alignItems: 'center',
                            fontSize: '12px'
                        }}>
                            <Space size="small">
                                <Skeleton.Avatar active size={12} shape="circle" />
                                <Skeleton.Input active style={{ width: '60px', height: '14px' }} />
                            </Space>
                            <Space size="small">
                                <Skeleton.Avatar active size={14} shape="circle" />
                                <Skeleton.Input active style={{ width: '80px', height: '16px' }} />
                            </Space>
                        </div>

                        <Skeleton.Button active style={{ 
                            width: '100%', 
                            height: '36px', 
                            borderRadius: '10px',
                            marginTop: '8px'
                        }} />
                    </Space>
                </div>
            </div>
            
            <style jsx>{`
                .featured-lot-skeleton-card {
                    animation: skeleton-loading 1.5s ease-in-out infinite;
                }
                @keyframes skeleton-loading {
                    0% { opacity: 0.6; }
                    50% { opacity: 1; }
                    100% { opacity: 0.6; }
                }
            `}</style>
        </>
    );
};

export default FeaturedLotCardSkeleton;

